<div
    class="button-container {{ class }}"
    [ngStyle]="{ width: width, 'line-height': lineHeight }">
    <div class="title">{{ title }}</div>
    <img class="chevron-down" src="assets/img/chevron_down.svg" />
</div>
